import { useMemo } from 'react';
import { BarChart } from '@antimatterhq/ui/components/barChart';
import { count } from '@antimatterhq/ui/utils/format';
import { Skeleton } from '@antimatterhq/ui/components/skeleton';
import { DatasourceSummary } from '@/types/api';

interface DataSourceSparklineProps {
  summaryWithAlertsAndMetrics: DatasourceSummary;
  className?: string;
  'data-testid'?: string;
  isLoading: boolean;
}

export const DataSourceSparkline = ({
  summaryWithAlertsAndMetrics,
  className,
  'data-testid': testId,
  isLoading,
}: DataSourceSparklineProps) => {
  const barChartData = useMemo(() => {
    return (summaryWithAlertsAndMetrics?.metrics?.eventsSparkLine ?? []).map(
      (value) => ({
        value,
      }),
    );
  }, [summaryWithAlertsAndMetrics]);

  if (isLoading) {
    return <Skeleton className={className} />;
  }

  return (
    <BarChart
      data={barChartData}
      className={className}
      dataKey="value"
      barRadius={2}
      tooltip={{
        formatter: (value) => `${count(value as number)} events`,
        position: { y: -24 },
      }}
      data-testid={testId}
    />
  );
};
